import * as React from 'react'
import Skeleton from '@mui/material/Skeleton'
import { Divider } from '@mui/material'

import SkeletonStack from 'components/Shared/SkeletonStack'
import styles from 'components/Shared/SkeletonStack/skeleton.module.scss'

type Props = {
  showHeaderSkeleton: boolean
  sectionCount: number
  height: number | string
  borderType?: string
  sx?: object
}

const CardSkeleton = (props: Props) => {
  const { showHeaderSkeleton, sectionCount, height, borderType, sx } =
    props || {}

  const getSkeletonSections = () => {
    const skeletons = []

    for (let i = 0; i < sectionCount; i++) {
      skeletons.push(
        <React.Fragment key={i}>
          {showHeaderSkeleton && (
            <Skeleton variant="text" width="60%" height={12} />
          )}
          <Skeleton
            variant="rectangular"
            height={height}
            className={`${styles[`rectangularSkeleton_${borderType}`]}`}
            sx={{ ...sx }}
          />
          {i < sectionCount - 1 && <Divider className={styles.dividerMargin} />}
        </React.Fragment>,
      )
    }
    return skeletons
  }

  return (
    <SkeletonStack>
      <>{getSkeletonSections()}</>
    </SkeletonStack>
  )
}

export default CardSkeleton
